<template>
  <tab-page-template
    component-name="MessageShow">

    <template #toolbar-items>
      <v-toolbar-title class="with-divider">
        取引データ記録
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn
          @click="openDeleteRequestDialog"
          color="primary"
          depressed
          :disabled="!['common', 'produce', 'producer'].includes(serviceType)">
        <v-icon class="mr-2">mdi-trash-can-outline</v-icon>
        データ削除リクエスト
      </v-btn>
    </template>

    <message-info :message="message"></message-info>

    <template #tab-items>
      <v-tab>
        データ操作記録
      </v-tab>
      <v-tab>
        データ利用記録
      </v-tab>

      <v-tab-item>
        <service-record-implementation-table-for-data
            :serviceRecords="dataServiceRecords">
        </service-record-implementation-table-for-data>
      </v-tab-item>
      <v-tab-item>
        <service-record-implementation-table
            :serviceRecords="serviceRecords"
            :messageHistoryId="messageHistoryId"
            :messageId="messageId">
        </service-record-implementation-table>
      </v-tab-item>
    </template>

    <simple-dialog
      v-model="dialogDeleteRequest"
      title-text="データ削除リクエスト"
      header-text="データ削除リクエストを送信します。よろしいですか？"
      applyText="削除リクエスト送信"
      @close="closeDeleteRequestDialog"
      @apply="requestDelete">

      <delete-request-form :message="message">
      </delete-request-form>
    </simple-dialog>
  </tab-page-template>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import PathInfoMixin from "@/router/PathInfoMixin";
import IoablePageMixin from "@/router/IoablePageMixin";
import TabPageTemplate from "@/components/templates/TabPageTemplate.vue";
import ServiceRecordImplementationTable from "@/components/pages/contract/MessageShow/ServiceRecordImplementationTable.vue";
import ServiceRecordImplementationTableForData from "@/components/pages/contract/MessageShow/ServiceRecordImplementationTableForData.vue";
import MessageInfo from "@/components/organisms/MessageInfo.vue";
import DeleteRequestForm from "@/components/pages/contract/MessageShow/DeleteRequestForm.vue";
import SimpleDialog from "@/components/organisms/SimpleDialog.vue";
import Qs from "qs";

export default {
  name: 'MessageShow',
  components: {
    TabPageTemplate,
    ServiceRecordImplementationTable,
    ServiceRecordImplementationTableForData,
    MessageInfo,
    DeleteRequestForm,
    SimpleDialog
  },
  mixins: [
    PathInfoMixin,
    IoablePageMixin
  ],
  props: {
    messageId: {
      type: String,
      required: true
    },
    messageHistoryId: {
      type: String,
      required: true
    },
    tradeContractId: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      dataImplementation: null,
      dataServiceRecords: [],
      dialogDeleteRequest: false
    }
  },
  computed: {
    ...mapState('hcs/message', ['message']),
    ...mapState('hcs/serviceRecord', ['serviceRecords']),
    ...mapGetters({
      hdsEntities: 'hds/entities',
      hcsClient: 'hcs/client'
    }),
    serviceType() {
      return this.message?.tradeContract?.serviceType;
    }
  },
  methods: {
    ...mapMutations({
      showSnackbar: 'showSnackbar',
    }),
    ...mapActions({
      gqlQueryAndLoad: 'hds/gqlQueryAndLoad'
    }),
    load() {
      return Promise.all([
        this.$store.dispatch('hcs/message/find', this.messageId),
        this.$store.dispatch('hcs/serviceRecord/findList', { messageId: this.messageId, q: { eventTypeEq: 'use', tradeContractIdEq: this.tradeContractId} }),
        this.loadDataServiceRecord()
      ])
    },
    async loadDataServiceRecord() {
      const {data: serviceRecords} = await this.hcsClient.get(`/messages/${this.messageId}/service_records`, {
        params: { q: {eventTypeNotEq: 'use' , tradeContractIdEq: this.tradeContractId} },
        paramsSerializer: function (params) {
          return Qs.stringify(params, { arrayFormat: 'brackets' })
        }
      });
      this.dataServiceRecords = serviceRecords
    },
    openDeleteRequestDialog() {
      this.dialogDeleteRequest = true
    },
    closeDeleteRequestDialog() {
      this.dialogDeleteRequest = false
    },
    requestDelete() {
      this.showSnackbar({
        message: '削除リクエストを送信中...',
        timeout: false,
        loading: true
      });
      this.$store.dispatch('hcs/message/requestDestroy', this.messageId)
        .then(() => {
          this.$store.commit({
            type: 'showSnackbar',
            message: `削除リクエストを送信しました`
          });
        })
        .catch(() => {
          this.$store.commit({
            type: 'showSnackbar',
            color: 'failed',
            message: `削除リクエストの送信に失敗しました`
          });
        })
    }
  },
}
</script>
